import { styled } from "@mui/material";
import { useBreakpoints } from "../hooks/BreakpointsHook";
import Bolt from "../Bolt_logo.png";

export default function Header() {
    const { isXs, isSm, isMd, isLg, isXl } = useBreakpoints();
    const Root = styled("div")((props) => ({
        display: "flex",
        //flex: "0 1 auto",
        padding: props.isSm || props.isXs ? "0px 50px 0px 50px" : "0px 50px 0px 50px",
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "stretch",
        //border: "1px solid rgba(0, 0, 0, 0.20)",
        background: "#FFF",
        width: "100%",
        boxSizing: 'border-box',
    }));

    const BoltHeaderContainer = styled("div")({
        display: "flex",
        alignItems: "center",  // To vertically align the image with the text
        gap: "10px"  // Adjust this to set space between the image and text
    });



    const getFontSizeForBoltHeader = () => {
        if (isXs) return "40px";
        if (isSm) return "50px";
        if (isMd) return "60px";
        if (isLg) return "70px";
        if (isXl) return "80px";
        return "80px"; // default size
    };

    const BoltLogo = styled("img")({
        height: getFontSizeForBoltHeader()  // This ensures the image has the same height as the BoltHeader text.
    });
    
    const getFontSizeForSecondHeader = (boltFontSize) => {
        return `${(parseInt(boltFontSize) * 5) / 8}px`;
    };

    const Container = styled("div")({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "24px",
        flex: "1 0 0",
    });

    const BoltHeader = styled("h1")({
        color: "#000000",
        fontFamily: "Roboto",
        fontSize: getFontSizeForBoltHeader(),
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "48px",
    });

    const SecondHeader = styled("h1")({
        color: "#000",
        fontFamily: "Roboto",
        fontSize: getFontSizeForSecondHeader(getFontSizeForBoltHeader()),
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "48px",
        margin: 0,  // Set margin to zero
    });

    const SubHeaderContainer = styled("div")((props) => ({
        display: "flex",
        flexDirection: "column",
        gap: props.isSm || props.isXs ? "1px" : "3px",  // Adjusted gap values
        marginBottom: props.isSm || props.isXs ? "36px" : "72px",
    }));

    return (
        <Root isXs={isXs} isSm={isSm} isMd={isMd} isLg={isLg} isXl={isXl}>
            <Container>
                <BoltHeaderContainer>
                    <BoltLogo src={Bolt} alt="Bolt Logo" />
                    <BoltHeader>Bolt Finance</BoltHeader>
                </BoltHeaderContainer>
                <SubHeaderContainer isXs={isXs} isSm={isSm} isMd={isMd} isLg={isLg} isXl={isXl}>
                    <SecondHeader>Real-World Assets</SecondHeader>
                    <SecondHeader>Analytics and Investment</SecondHeader>
                </SubHeaderContainer>
            </Container>
        </Root>
    );
}
